import { useMap } from "context/mapContext";
import { useLoading, handleLoading } from "context/LoadingContext";
import React, { useEffect, useState } from "react";
import getEsriDataFromLayer from "context/contextFunctions/getEsriDataFromLayer";
import PaletteHistoryCard from "components/PaletteHistoryCard";

export default function PaletteDetails() {
  const [map, dispatchMap] = useMap();
  const [, dispatchLoading] = useLoading();
  const { selectedPalette, palettesHistoryTable, view } = map;

  const [transferTaskDetails, setTransferTaskDetails] = useState([]);

  const handleBack = () => {
    dispatchMap({
      type: "INIT",
      payload: {
        paletteTrackingComponentMode: "palettesList",
        selectedPalette: null,
      },
    });
  };

  useEffect(() => {
    (async () => {
      handleLoading(dispatchLoading, true);
      try {
        const token = localStorage.getItem("token");
        const orderByFields = ["created_date DESC"];
        if (palettesHistoryTable && view && token) {
          const { res: selectedPaletteHistoryRes } = await getEsriDataFromLayer(
            {
              featureLayer: palettesHistoryTable,
              query: `Pallet_ID='${selectedPalette.Pallet_ID}'`,
              orderByFields,
            }
          );

          setTransferTaskDetails(selectedPaletteHistoryRes);
        }
      } catch (error) {
        console.log(error);
      }
      handleLoading(dispatchLoading, false);
    })();
  }, [view, palettesHistoryTable]);

  return (
    <div
      className="meters"
      style={{
        position: "relative",
        // alignContent: transferTaskDetails?.length ? "normal" : "center",
      }}
    >
      <div className="btn_group mb-3">
        <button
          type="button"
          className="btn btn--icon btn--outline--primary"
          onClick={handleBack}
          style={{ height: "50px" }}
        >
          <i className="fa-solid fa-arrow-left end" />
          Back
        </button>
      </div>
      {transferTaskDetails?.length ? (
        <PaletteHistoryCard
          list={transferTaskDetails}
          id={selectedPalette.Pallet_ID}
        />
      ) : (
        <div className="text-center">No History Found</div>
      )}
    </div>
  );
}
